import { render, staticRenderFns } from "./colorsVue.vue?vue&type=template&id=913f0450&scoped=true"
import script from "./colorsVue.vue?vue&type=script&lang=js"
export * from "./colorsVue.vue?vue&type=script&lang=js"
import style0 from "./colorsVue.vue?vue&type=style&index=0&id=913f0450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913f0450",
  null
  
)

export default component.exports